import IFramePage from '@/components/common/IFramePage';
import { useGetMenuHeaderQuery } from '@/features/api/endpoints/LayoutEndpoints';
import type { IFrameLinkParams } from '@/models/common.type';
import { useDocumentTitle } from '@mantine/hooks';
import { useTranslate } from '@tolgee/react';

const HelpPage = () => {
  const { t } = useTranslate();

  const { data } = useGetMenuHeaderQuery();

  useDocumentTitle(t('header.help'));

  if (data?.helpType === 'iframe') {
    const params = data.helpParams as unknown as IFrameLinkParams;

    return (
      <IFramePage
        type="iframe"
        link={data.helpLink ?? ''}
        params={{
          ...params,
          title: t('header.help'),
        }}
      />
    );
  }

  return null;
};

export default HelpPage;
